import React, { useEffect } from "react";
import "./loginPage.css";
import logo from "../../assets/logo.png";
import toast, { Toaster } from "react-hot-toast";

import { useLoginPage } from "../../customHooks/LoginPage/useLoginPage";

export default function LoginPage() {
  const hookProps = useLoginPage();
  const { handleAuthFlow } = hookProps;

  useEffect(() => {
    handleAuthFlow(); // Handle authentication flow on component mount
  }, []);
  return (
    <>
     
    </>
  );
}
